import { Injectable } from '@angular/core';
import { asBlob } from 'html-docx-js-typescript';
import { saveAs } from 'file-saver'

@Injectable({
  providedIn: 'root'
})
export class HtmldocxService {
  public cssStyles=".mat-typography { font: 400 15px sans-serif; letter-spacing: normal; }  h2 { font: 500 20px Roboto, "+"Helvetica Neue"+", sans-serif; letter-spacing: normal; margin: 0 0 16px; text-align: center; }  h3 { font: 400 17.5px Roboto, "+"Helvetica Neue"+", sans-serif; letter-spacing: normal; margin: 0 0 16px; } .table-bordered { border: 1px solid #dee2e6; } .table { width: 100%; margin-bottom: 1rem; color: #212529; margin-top: 20px; } table { border-collapse: collapse; } thead { display: table-header-group; vertical-align: middle; border-color: inherit; } tr { display: table-row; vertical-align: inherit; border-color: inherit; } .table .thead-dark th { color: #fff; background-color: #343a40; border-color: #454d55; } body .table thead th { background: #f3f5ff; } .table-bordered thead td, .table-bordered thead th { border-bottom-width: 2px; } .table thead th { vertical-align: bottom; border-bottom: 2px solid #dee2e6; } .table-bordered td, .table-bordered th { border: 1px solid #dee2e6; } .table td, .table th { padding: 0.75rem; vertical-align: top; border-top: 1px solid #dee2e6; } th { text-align: inherit; text-align: -webkit-match-parent; } tbody { display: table-row-group; vertical-align: middle; border-color: inherit; }";

  constructor() { 
  }
  convert(htmlString: string, filename: string,  element: Element,options){
    // let style = getComputedStyle(element);
    const joinHtmlCss = require('juice');
  
    const elem = document.querySelector('#element-to-export');
  const stx = getComputedStyle(elem);
  console.log(stx);
    const htmlContent = joinHtmlCss.inlineContent(htmlString, this.cssStyles);
    // let htmlContent = htmlString;
    asBlob(htmlContent, options).then(data => {
      saveAs(data, filename+'.docx'); // save as docx file
    }) 
  
  
    // const request = require('request')
      
  
    // let getStyle = new Promise((resolve, reject) => {
    //   request('GET','reponse', './business-plan.component.scss')
    //     .then(data =>
    //       data.text().then(scss => { 
    //         resolve(scss);
    //       })
    //     )
    //     .catch(error => reject(error));
    // });
  
    // getStyle
    //   .then(scss => {
    //     let htmlContent = joinHtmlCss.inlineContent(htmlString, scss);
    //     asBlob(htmlContent, this.fetchOptions[1]).then(data => {
    //       saveAs(data, filename+'.docx') // save as docx file
    //     }) 
    //   })
    //   .catch(error => {
    //     console.log(error);
    //   });
  }
}